import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BarChart from './barChart';
import LineChart from './lineChart';

class FareTrends extends Component {
  static propTypes = {
    showMonth: PropTypes.bool,
    fareTrendsData: PropTypes.array,
    dividerWidth: PropTypes.number,
    lineHeight: PropTypes.number,
    svgHeight: PropTypes.number,
    maxHeightPercent: PropTypes.number,
    keyFrameAnimation: PropTypes.func,
    openCalendar: PropTypes.func,

    fareTrendWrapperClasses: PropTypes.string,
    fareTrendWrapperStyle: PropTypes.object,
    wrapperClasses: PropTypes.string,
    wrapperStyles: PropTypes.object,
    svgClasses: PropTypes.string,
    svgStyles: PropTypes.object,
    polyLineClasses: PropTypes.string,
    polyLineStyles: PropTypes.object,
    colors: PropTypes.object,

    dateTxtAttributes: PropTypes.object,
    circleAttributes: PropTypes.object,
    priceAttributes: PropTypes.object,
    lineAttributes: PropTypes.object,
    selectedDividerAttr: PropTypes.object,
    otherDividerAttr: PropTypes.object,

    checkin: PropTypes.object,
    selectOtherDate: PropTypes.func,
    selectedDatePrice: PropTypes.func,
    selectedDate: PropTypes.string,

    type: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { type = 'line' } = this.props;
    if (type === 'bar') {
      return <BarChart {...this.props} />;
    }
    return <LineChart {...this.props} />;
  }
}

export default FareTrends;
